import { jsx as _jsx } from "react/jsx-runtime";
import { isValidBusinessObject, User } from '@iotv/datamodel-core';
import { Skeleton } from '@mui/material';
import { useContext } from 'react';
import { SingleEntityAutoQuery } from '../../generic/EntityAutoQuery';
import { AlertManagementContext } from './AlertManagementContext';
import { getVisibleGroups } from '../../../helpers/queryHelpers';
export const UserSelector = () => {
    const [{ loaded, isAdmin, contextCustomer, contextUser }, dispatch] = useContext(AlertManagementContext);
    if (!loaded)
        return _jsx(Skeleton, { variant: "rounded", width: "10em", height: "2.5em" });
    if (isAdmin === undefined || isAdmin === false || contextCustomer === undefined)
        return;
    /** Dispatches new user but also fetches their visible groups */
    const selectUser = (u) => {
        dispatch({ contextUser: new User(u), visibleGroups: [] });
        //dispatch({ visibleGroups: []})
        getVisibleGroups(u).then((g_res) => {
            if (g_res.data) {
                dispatch({ visibleGroups: g_res.data });
            }
        });
    };
    return (_jsx(SingleEntityAutoQuery, { contextObject: contextCustomer, entityType: "User", currentEntity: contextUser, setCurrentEntity: (u) => isValidBusinessObject(u) && selectUser(u), label: "User", fullWidth: false }));
};
